import React, { Component } from "react";
import "./Footer.css"

function Navbar() {
    return (
        <nav className="main-footer">
          <a href="/" className="footer-brand-name">
            Testuj.pl
          </a>
          <footer className="footer-center">
            <p>Author: Bi Dżej</p>
            <p>2022 All rights reserved ©</p>
          </footer>
        </nav>
      );
}

export default class Footer extends Component {
    render() {
        return (
            <Navbar />
        )
    }
}